export default function (nga, admin) {

    var center = admin.getEntity('centers');
    center.listView()
        .title('{{ "Centers" | translate }}')
        .fields([
            nga.field('name', 'text')
                .label('Name')
                .isDetailLink(true)
        ])
        .filters([
            nga.field('q', 'template')
                .label('')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
        ])
        .sortField('name')
        .sortDir('DESC')
    return center;
}



// WEBPACK FOOTER //
// ./js/centers/config.js